import { sendCode } from '@/api/Sms'

export default {
    data() {
        const validateMobile = (rule, value, callback) => {
            if (!value) {
                const msg = this.$store.getters.language === 'en' ? 'Please enter your mobile' : '请输入手机号'
                return callback(new Error(msg))
            } else {
                const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
                if (reg.test(value)) {
                    callback()
                } else {
                    const msg = this.$store.getters.language === 'en' ? 'Please enter your password' : '请输入正确的手机号'
                    return callback(new Error(msg))
                }
            }
        }
        const validatePass = (rule, value, callback) => {
            if (value.length < 6 || value.length > 16) {
                const msg = this.$store.getters.language === 'en' ? 'The password must contain 6 to 16 characters' : '密码长度需6-16位'
                callback(new Error(msg))
            } else {
                callback()
            }
        }
        const pwdAgainCheck = (rule, value, callback) => {
            if (value.length < 6 || value.length > 16) {
                const msg = this.$store.getters.language === 'en' ? 'The password must contain 6 to 16 characters' : '密码长度需6-16位'
                callback(new Error(msg))
            } else if (this.rForm.password !== this.rForm.password_confirmation) {
                const msg = this.$store.getters.language === 'en' ? 'Two input password is inconsistent!' : '两次输入密码不一致！'
                callback(new Error(msg))
            } else {
                callback()
            }
        }
        const pwdAgainCheck_reset = (rule, value, callback) => {
            if (value.length < 6 || value.length > 16) {
                const msg = this.$store.getters.language === 'en' ? 'The password must contain 6 to 16 characters' : '密码长度需6-16位'
                callback(new Error(msg))
            } else if (this.rForm.new_password !== this.rForm.new_password_confirmation) {
                const msg = this.$store.getters.language === 'en' ? 'Two input password is inconsistent!' : '两次输入密码不一致！'
                callback(new Error(msg))
            } else {
                callback()
            }
        }
        return {
            loading: false,
            pwdType: 'password',
            codeBtn: true,
            language: this.$store.getters.language,
            codeName: this.$store.getters.language === 'en' ? 'Get Code' : '获取验证码',
            timer: 'null',
            rRules: {
                mobile: [{ required: true, validator: validateMobile, trigger: 'blur' }],
                password: [{ required: true, validator: validatePass, trigger: 'blur' }],
                password_confirmation: [{ required: true, validator: pwdAgainCheck, trigger: 'blur' }],
                code: [{ required: true, message: this.$store.getters.language === 'en' ? 'Please enter the verification code' : '请输入验证码', trigger: 'blur' }]
            },
            resetRules: {
                mobile: [{ required: true, validator: validateMobile, trigger: 'blur' }],
                code: [{ required: true, message: this.$store.getters.language === 'en' ? 'Please enter the verification code' : '请输入验证码', trigger: 'blur' }],
                new_password: [{ required: true, validator: validatePass, trigger: 'blur' }],
                new_password_confirmation: [{ required: true, validator: pwdAgainCheck_reset, trigger: 'blur' }]
            }
        }
    },
    methods: {
        showPwd() {
            if (this.pwdType === 'password') {
                this.pwdType = ''
            } else {
                this.pwdType = 'password'
            }
        },

        hancleChangeType(type) {
            this.$emit('hancleChange', type)
        },

        bindKeyMobile() { // 输入手机号 键盘输入时触发
            var mobile = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/

            if (mobile.test(this.rForm.mobile)) {
                this.codeBtn = false
            } else {
                this.codeBtn = true
            }

            clearInterval(this.timer)
        },

        getCode() { // 获取验证码
            const { language } = this
            if (!this.rForm.mobile) {
                const msg = language === 'en' ? 'mobile required' : '手机号码不能为空'
                this.$message.warning(msg)
                return
            }
            let seconds = 60

            this.codeBtn = true

            const data = {
                mobile: this.rForm.mobile,
                scene: 'register'
            }

            sendCode(data).then(res => {
                if (res.code === 200) {
                    this.$notify({
                        title: this.$t('Notification.suc_title'),
                        message: this.$t('Notification.suc_send_msg'),
                        type: 'success',
                        duration: 2000
                    })
                    this.timer = setInterval(() => {
                        seconds--
                        if (seconds < 0) {
                            this.codeName = this.$t('Notification.codeAgain')
                            this.codeBtn = false
                            clearInterval(this.timer)
                        } else {
                            this.codeName = language === 'en' ? 'After ' + seconds + 's Get Code' : seconds + 's后获取验证码'
                            this.codeBtn = true
                        }
                    }, 1000)
                }
            })
        },

        submit() {
            this.$refs['rForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.rForm)
                }
            })
        }
    }
}
